import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { useWhoAmIQueryRequest, useModulesEnabledRequest } from "../../hooks/useApi";

export const LoginStateContext = createContext();

export const LoginStateProvider = ({ children }) => {

  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // eslint-disable-next-line no-empty-pattern
  const [{}, whoAmI] = useWhoAmIQueryRequest();
  const [{ data: rawModulesData, loading: modulesLoading }] = useModulesEnabledRequest();

  const getCurrentUser = useCallback(async () => {
    try {
      const response = await whoAmI();

      return response.data;
    } catch {
      return null;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {};

  useEffect(() => {
    (async () => {
      const user = await getCurrentUser();
      setCurrentUser(user);
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCurrentUser]);

  const enabledModules = useMemo(() => {
    const parsed = typeof rawModulesData === 'string' ? JSON.parse(rawModulesData) : rawModulesData;
    return Array.isArray(parsed) ? parsed.map((m) => m.code) : [];
  }, [rawModulesData]);

  const providerValue = {
    currentUser,
    userLoading: loading || modulesLoading,
    setCurrentUser,
    logout,
    enabledModules,
  };

  return (
    <LoginStateContext.Provider value={providerValue}>
      {children}
    </LoginStateContext.Provider>
  );
};
